import { ID, IDPrefixes, PrefixedID } from '@griply/types';

import { createPrefixId, getPrefixedIdPrefix } from './prefix-id';

export const buildTaskTagsMap = (
  taskIds: ID[],
  relationshipsMap: Record<PrefixedID, PrefixedID[]>,
): Map<ID, ID[]> => {
  const result = new Map<ID, ID[]>();

  for (const taskId of taskIds) {
    const prefixedTaskId = createPrefixId(taskId, IDPrefixes.Task);
    const relatedIds = relationshipsMap[prefixedTaskId] ?? [];

    const tagIds = relatedIds
      .filter((refId) => getPrefixedIdPrefix(refId) === IDPrefixes.Tag)
      .map((refId) => refId.substring(refId.indexOf(':') + 1));

    result.set(taskId, tagIds);
  }

  return result;
};
